import { connect } from "react-redux";
import Landing from "../../components/Landing/Landing";

export const mapStateToProps = () => ({})

export default connect(mapStateToProps)(Landing)